import React, { useEffect, useRef } from 'react';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js';
// import { TextGeometry } from 'three/addons/geometries/TextGeometry.js';
import * as THREE from 'three';
import kawsUrl from '../models/Kaws.obj';

function ThreeScene({ width, height, wireframe, wireframeKaw }) {
  const containerRef = useRef(null);
  const renderer = useRef(null);
  const camera = useRef(null);
  const objLoader = useRef(null);
  const sceneRef = useRef(null);

  useEffect(() => {
    const scene = new THREE.Scene();
    sceneRef.current = scene;
    scene.background = new THREE.Color(0x121212);
    camera.current = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);
    camera.current.position.set(7, 6, 0);
    renderer.current = new THREE.WebGLRenderer();

    renderer.current.setSize(width, height);
    containerRef.current.appendChild(renderer.current.domElement);

    const orbit = new OrbitControls(camera.current, renderer.current.domElement);

    objLoader.current = new OBJLoader();
    objLoader.current.load(kawsUrl, function (object) {
      object.scale.set(100, 100, 100);
      object.position.set(0, -2, 0);
      object.traverse(function (child) {
        if (child instanceof THREE.Mesh) {
          // Atualize o material de cada malha do objeto
          child.material = new THREE.MeshLambertMaterial({ color: 0xff0000, wireframe: wireframeKaw });
        }
      });
      scene.add(object);
      function animate() {
        requestAnimationFrame(animate);
        object.rotation.y += .005;
      }

      // Chama a função 'animate' pela primeira vez para iniciar a animação
      animate();
    }, function (xhr) {
      console.log(xhr.loaded / xhr.total * 100);
    }, function (error) {
      console.log(error);
    });

    // const geometry = new THREE.BoxGeometry(1);
    // const material = new THREE.MeshLambertMaterial({ color: 0xFF0FF0, wireframe: false });
    // const cube = new THREE.Mesh(geometry, material);
    // scene.add(cube);
    // cube.position.y = 1.4;

    // const planeGeometry = new THREE.PlaneGeometry(10, 10);
    // const planeMaterial = new THREE.MeshBasicMaterial({ color: 0x491cc4, side:  THREE.DoubleSide })
    // const plane = new THREE.Mesh(planeGeometry, planeMaterial);
    // scene.add(plane);
    // plane.rotation.x = -0.5 * Math.PI;

    const sphereGeometry = new THREE.SphereGeometry(1.4);
    const sphereMaterial = new THREE.MeshNormalMaterial({ color: 0x0000FF, wireframe: wireframe });
    const sphere = new THREE.Mesh(sphereGeometry, sphereMaterial);
    scene.add(sphere);
    sphere.scale.set(3, 3, 3);
    sphere.position.set(0, 1.5);

    // const gridHelper = new THREE.GridHelper(10, 10);
    // scene.add(gridHelper);

    const ambientLight = new THREE.AmbientLight(0xFFFFFF, .5);
    const directionalLight = new THREE.DirectionalLight(0xFFFFFF, 1);
    directionalLight.position.set(10, 10, 1).normalize();
    scene.add(ambientLight, directionalLight);

    camera.current.position.z = 5;
    orbit.update();

    function animate() {
      requestAnimationFrame(animate);
      // cube.rotation.x += 0.01;
      // cube.rotation.y += 0.01;
      sphere.rotation.y -= 0.001;
      sphere.rotation.x -= 0.001;
      renderer.current.render(scene, camera.current);
    }
    animate();

    function handleResize() {
      renderer.current.setSize(width, height);
      camera.current.aspect = width / height;
      camera.current.updateProjectionMatrix();
    }

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
      // eslint-disable-next-line react-hooks/exhaustive-deps
      containerRef.current.removeChild(renderer.current.domElement);
    };
  }, [height, width, wireframe, wireframeKaw]);

  return <div ref={containerRef} />;
}

export default ThreeScene;